export const DYNAMIC_TABLE_SETTINGS_SIDEBAR = {
  DYNAMIC_TABLE_SETTINGS_TITLE: {
    key: 'DYNAMIC_TABLE_SETTINGS_TITLE',
    value: "Dynamic Table Settings"
  },
  DYNAMIC_TABLE_VARIABLE_NAME: {
    key: 'DYNAMIC_TABLE_VARIABLE_NAME',
    value: "Variable Name"
  },
  SHOW_HEADER_SETTING: {
    key: 'SHOW_HEADER_SETTING',
    value: 'Show header'
  },
  SHOW_TITLE_SETTINGS: {
    key: 'SHOW_TITLE_SETTINGS',
    value: 'Show title',
  },
  SHOW_TITLE_IN_ALL_PAGES: {
    key: 'SHOW_TITLE_IN_ALL_PAGES',
    value: 'Show title in all pages',
  },
  SHOW_FOOTER_SETTINGS: {
    key: 'SHOW_FOOTER_SETTINGS',
    value: 'Show footer',
  },
  SHOW_SERIAL_NUMBERS: {
    key: 'SHOW_SERIAL_NUMBERS',
    value: 'Show serial numbers',
  },
  GRID_STYLING_LABEL: {
    key: 'GRID_STYLING_LABEL',
    value: 'Grid styling for {{info}}',
  },
  HEADER_STYLING_LABEL: {
    key: 'HEADER_STYLING_LABEL',
    value: 'Header styling',
  },
  SPACING_LABEL: {
    key: 'SPACING_LABEL',
    value: 'Spacing',
  },
  TOP_LABEL: {
    key: 'TOP_LABEL',
    value: 'Top'
  },
  BOTTOM_LABEL: {
    key: 'BOTTOM_LABEL',
    value: 'Bottom'
  },
  RIGHT_LABEL: {
    key: 'RIGHT_LABEL',
    value: 'Right'
  },
  LEFT_LABEL: {
    key: 'LEFT_LABEL',
    value: 'Left'
  },
  BACKGROUND_LABEL: {
    key: 'BACKGROUND_LABEL',
    value: 'Background'
  },
  BORDER_LABEL: {
    key: 'BORDER_LABEL',
    value: 'Border'
  },
  CELL_STYLING_LABEL: {
    key: 'CELL_STYLING_LABEL',
    value: 'Cell styling for {{info}}'
  },
  SHOW_GROUP_HEADER_SETTING: {
    key: 'SHOW_GROUP_HEADER_SETTING',
    value: 'Show group header'
  },
  SHOW_HEADER_IN_ALL_PAGES: {
    key: 'SHOW_HEADER_IN_ALL_PAGES',
    value: "Show header in all pages"
  },
  SHOW_HEADER_IN_ALL_PAGES_TOOLTIP: {
    key: 'SHOW_HEADER_IN_ALL_PAGES_TOOLTIP',
    value: "Repeat the table header when table overflows to new pages"
  },
  SHOW_TITLE_IN_ALL_PAGES_TOOLTIP: {
    key: 'SHOW_TITLE_IN_ALL_PAGES_TOOLTIP',
    value: "Repeat the table title when table overflows to new pages"
  },
  EMPTY_MAPPING_NOTE: {
    key: 'EMPTY_MAPPING_NOTE',
    value: 'Click on each column of the table to populate the contents of the table'
  },
  EMPTY_TEXT_LABEL: {
    key: 'EMPTY_TEXT_LABEL',
    value: 'empty text'
  }
}

export const DYNAMIC_TABLE_OPERATIONS = {
  REMOVE_COLUMN: {
    key: "REMOVE_COLUMN",
    value: "Remove column"
  },
  ADD_COLUMN: {
    key: "ADD_COLUMN",
    value: "Add column"
  },
  MOVE_COLUMN: {
    key: "MOVE_COLUMN",
    value: "Move column"
  },
  RESIZE_COLUMN: {
    key: "RESIZE_COLUMN",
    value: "Resize column width"
  },
  CLOSE_OPTIONS: {
    key: "CLOSE_OPTIONS",
    value: "Close"
  },
  UNABLE_TO_RESIZE_COLUMN: {
    key: "UNABLE_TO_RESIZE_COLUMN",
    value: "Some columns do not fit within the page dimensions"
  },
  SOME_COLUMNS_ARE_TOO_SMALL_ON_RESIZE: {
    key: "SOME_COLUMNS_ARE_TOO_SMALL_ON_RESIZE",
    value: "Some columns become too small on resize, please try minimizing the width of other columns to make more space"
  },
  CANNOT_MINIMIZE_COLUMN: {
    key: "CANNOT_MINIMIZE_COLUMN",
    value: "Cannot minimize column, becomes too small for content"
  },
  ROW_RESIZE_TO_MIN_CONTENT: {
    key: "ROW_RESIZE_TO_MIN_CONTENT",
    value: 'Cannot resize to given height, instead resized rows to fit the content. Adjust the content of cells or padding to reduce the height of the row'
  },
  RESIZE_COLUMN_WARN:{
    key: 'RESIZE_COLUMN_WARN', value: 'Cannot resize column to given dimension since it is too small!!'
  },
  DROPPED_ELEMENT_NOT_SUPPORT_WARN: {
    key: 'DROPPED_ELEMENT_NOT_SUPPORT_WARN', value: 'Dropped element is not supported within this structure'
  },
  DELETE_CONFIRMATION_MESSAGE: {
    key: 'DELETE_CONFIRMATION_MESSAGE',
    value: 'This action will delete the selected column and any dependent columns. Do you want to proceed?'
  },
  DELETE_CONFIRMATION_YES: {
    key: 'DELETE_CONFIRMATION_YES',
    value: 'Yes'
  },
  DELETE_CONFIRMATION_NO: {
    key: 'DELETE_CONFIRMATION_NO',
    value: 'No'
  }
}